import { Grid, makeStyles, MobileStepper } from "@material-ui/core";
import React, { useState } from "react";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import Megaview from "../MegaView";
import "./ClickToViewMegaViewCarousal.scss";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const ClickToViewMegaViewCarousal = (props) => {
  const [activeStep, setActiveStep] = useState(0);
  const [isHover, setIsHover] = useState(false);
  const toggleHover = () => {
    setIsHover(!isHover);
  };
  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  // const theme = createTheme({
  //   overrides: {
  //    MuiStepIcon: {
  //     root: {
  //       '&$completed': {
  //         color: '#000000 !important',
  //       },
  //       '&$active': {
  //         color: '#db4435 !important',
  //       },
  //     },
  //   },}
  // });

  const useStyles = makeStyles({
    dots: {
      // width: "100px",
      justifyContent: "space-between",
      color: "#ffffff",
    },
    dot: {
      width: "10px",
      height: "10px",
      backgroundColor: "#f5e7e2",
    },
    // root: {
    //   color: "blue",
    //   "&$active": {
    //     color: "db4435"
    //   },
    //   "&$completed": {
    //     color: "#db4435 !important"
    //   }
    // },
    dotActive: {
      backgroundColor: "#db4435",
    },
    completed: {
      // color:'#db4435'
    },
  });

  const classes = useStyles();

  return (
    <div
      className={
        props.ClickToViewMegaViewCarousalData.additionalCards
          ? "body-container"
          : "body-container clickToViewMegaView-main"
      }
    >
      <Grid container direction="row" spacing={3}>
        <Grid
          item
          container
          direction="column"
          justify="space-around"
          md={4}
          className="carousal-title-area appsgridshadow"
        >
          {props.ClickToViewMegaViewCarousalData.data.map((item, index) => (
            <Grid
              className={
                index === activeStep
                  ? "carousal-padding clickToViewCard-title clickToViewCard-title-black "
                  : "carousal-padding clickToViewCard-title"
              }
              item
              key={index}
              onClick={() => handleStepChange(index)}
            >
              {item.title}
            </Grid>
          ))}
          <p style={{ color: "#DB4435", textTransform: "uppercase" }}>
            {props.ClickToViewMegaViewCarousalData.data[0].bottom}
          </p>
        </Grid>
        <Grid item md={8} className="carousal-padding carousal-right-box">
          <div role = "button" tabIndex={0} onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
            <AutoPlaySwipeableViews
              axis="x"
              index={activeStep}
              onChangeIndex={!isHover && handleStepChange}
              enableMouseEvents
            >
              {props.ClickToViewMegaViewCarousalData.data.map((item, index) => (
                <div key={index}>
                  <div>
                    <Megaview
                      displayFIndoutMore="no"
                      MegaviewData={[item.card1data]}
                      key={index}
                    />
                  </div>
                  {props.ClickToViewMegaViewCarousalData.additionalCards && (
                    <div className="mt-20">
                      <Megaview
                        displayFIndoutMore="no"
                        MegaviewData={[item.card2data]}
                        key={index}
                      />
                    </div>
                  )}
                </div>
              ))}
            </AutoPlaySwipeableViews>
          </div>
        </Grid>
      </Grid>
      {/* <ThemeProvider theme={theme}> */}
      <MobileStepper
        steps={props.ClickToViewMegaViewCarousalData.data.length}
        position="static"
        variant="dots"
        style={{ background: "white" }}
        className="megaview-carousal-indicator"
        activeStep={activeStep}
        classes={{
          dots: classes.dots,
          progress: classes.completed,
          dotActive: classes.dotActive,
          dot: classes.dot,
        }}
      />
      {/* </ThemeProvider> */}
    </div>
  );
};

export default ClickToViewMegaViewCarousal;
